var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zoom-resetter"},[_c('button',{staticClass:"zoom-resetter__btn btn btn--primary btn--small",attrs:{"disabled":_vm.zoom === _vm.$options.defaultZoom},on:{"click":_vm.onResetZoomRequested}},[_vm._v("\n    "+_vm._s(_vm.$t('wizard_step.zoom.reset_zoom_btn_label'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }